/**
 * Волна D (docs/MIGRATION_ROUTER.md §5).
 * Было: <PrivateRoute path='/cart/success/:key'>.
 * Не-exact: хвосты ловит cart/success/$key/$.tsx.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../../../CacheDataRoute';
import ThanksForPurchase from '@routes/ThanksForPurchase';

export const Route = createFileRoute('/cart/success/$key/')({
  component: () => (
    <CacheDataRoute component={ThanksForPurchase} path='/cart/success/:key' />
  )
});
